import { render, staticRenderFns } from "./addTransportModule.page.vue?vue&type=template&id=6f6881dc&scoped=true&"
import script from "./addTransportModule.page.vue?vue&type=script&lang=js&"
export * from "./addTransportModule.page.vue?vue&type=script&lang=js&"
import style0 from "./addTransportModule.page.vue?vue&type=style&index=0&id=6f6881dc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f6881dc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\mzkj\\要炼\\yl-pc-business\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6f6881dc')) {
      api.createRecord('6f6881dc', component.options)
    } else {
      api.reload('6f6881dc', component.options)
    }
    module.hot.accept("./addTransportModule.page.vue?vue&type=template&id=6f6881dc&scoped=true&", function () {
      api.rerender('6f6881dc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/distribution/transport/addTransportModule.page.vue"
export default component.exports